import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface TemplateProps {
  pageId: number
}
const categoryTitle = '金融/不動産'
const baseUrl = '/cases/finance/'

const Template: React.FC<TemplateProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
